var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "33e907e8-b4d4-46f0-b313-8fe63ffda81e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215,
    height: 140,
    viewBox: "0 0 215 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b3281f77-6ee5-441a-a4ca-93c2ca1d939a",
    x1: 43.91,
    y1: 103.55,
    x2: 214.33,
    y2: 103.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3dbfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ff9a"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HighPass") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 140,
    style: {
      fill: "#262728"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,68.1H121.82c-33,0-76.24,9.09-76.24,71.9H215Z",
    style: {
      fill: "#fff",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.33,68.1H121.16c-33,0-76.25,9.09-76.25,71.9",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#b3281f77-6ee5-441a-a4ca-93c2ca1d939a)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighPass);
export default __webpack_public_path__ + "static/media/HighPass.24260661.svg";
export { ForwardRef as ReactComponent };